import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/auth/use-auth'
import { IPerformanceLog } from '@/types/performanceLog'
import { authenticatedApi } from '@/utils/api'

import { QUERY_KEY_PERFORMANCE_LOGS } from './usePerformanceLogs'

const ELEVATED_ROLES = ['super_admin', 'admin']

/**
 * Fetch count of pending performance log entries visible to the current user.
 * Admins/super_admins see all; managers only see logs where they are the actingManagerId.
 * Used for the sidebar badge. Polls every 60 seconds.
 */
export const usePendingApprovalsCount = () => {
  const { userId, userRoles } = useAuth()

  return useQuery({
    queryKey: [QUERY_KEY_PERFORMANCE_LOGS, 'pending-count', userId, userRoles],
    queryFn: async () => {
      const logs = await authenticatedApi
        .get('performance-log', { searchParams: { status: 'Pending' } })
        .json<IPerformanceLog[]>()

      const isElevated = userRoles.some((r) => ELEVATED_ROLES.includes(r))
      if (isElevated) return logs.length

      return logs.filter((log) => log.actingManagerId === userId).length
    },
    refetchInterval: 60_000,
    staleTime: 30_000,
  })
}
